export default {
  Detail: {
    title: "Cấp phát theo nhân viên",
    titleOrganization: "Cấp phát theo phòng ban",
    ProcessDate: "Ngày cấp phát",
    Reason: "Lý do cấp phát",
    attach: "Đính kèm",
    addEmployee: "Thêm nhân viên",
    assetbyEmployee: "Tài sản được cấp phát",
    attachFile: "Tệp đính kèm",
    addAsset: "Thêm dòng",
    quickSearch: "Chọn nhanh",
    assetType: "Loại tài sản",
    quantity: "Số lượng",
    assetStatus: "Tình trạng",
    QuantityLost: "SL mất",
    assetCode: "Mã tài sản",
    assetName: "Tên tài sản",
    UserType: "Đối tượng sử dụng",
    EmployeeUse: "Nhân viên sử dụng",
    OrganizationUnitUse: "Đơn vị sử dụng",
    location: "Vị trí tài sản",
    specification: "Quy cách",
    addAttach: "Thêm đính kèm",
    name: "Tệp đính kèm",
    size: "Dung lượng",
    dowload: "Tải về",
    JobPosition: "Vị trí tài sản",
    AssetStatus: "Trạng thái",
    EmptyAttact: "Chưa có tệp đính kèm nào",
    InfoAssetContent: "Đã cấp được {0} trên {1} tài sản theo định mức",
    quantityAllo: "SL cấp phát",
    locationName: "Tên vị trí tài sản",
    locationCode: "Mã vị trí tài sản",
    quantityRemain: "Số lượng tồn",
    Representative: "Người đại diện",
    notUsingQuantity: "Số lượng chưa sử dụng",
    notUsingQuantityShort: "SL chưa sử dụng",
    allocationQuantity: "Số lượng cấp phát",
    allocationQuantityShort: "SL cấp phát",
    LostReason: "Lý do mất",
    ErrorDetailEmpty: "Chưa nhập chi tiết tài sản cho nhân viên <<{0}>>. Vui lòng kiểm tra lại.",
    ErrorLocationEmpty: "Chưa chọn vị trí tài sản cho nhân viên <<{0}>>. Vui lòng kiểm tra lại.",
    ErrorQuantiryGreaterRemainQuantity:
      "Số lượng cấp phát lớn hơn số lượng tồn của tài sản <<{0}>> - nhân viên <<{1}>>. Vui lòng kiểm tra lại.",
    ErrorQuantiryEqual0:
      "Chưa nhập số lượng cho tài sản <<{0}>> - nhân viên <<{1}>>. Vui lòng kiểm tra lại.",
    ErrorNoEmployee: "Chưa chọn nhân viên để cấp phát. Vui lòng kiểm tra lại.",
    WarringLocationParent: "Không được chọn chỉ tiêu cha. Vui lòng kiểm tra lại.",
    ErrorNotEnterQuantity: "Chưa nhập số lượng.",
    ErrorAllocationQuantity: "Số lượng cấp phát không được > số lượng chưa sử dụng.",
    OccurenceDateInValid:
      "Ngày cấp phát không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất (##0##)",
  },

  SelectEmployeeForm: {
    JobPositionName: "Vị trí công việc",
    EmployeeCode: "Mã nhân viên",
    FullName: "Họ và tên",
    OrganizationUnitName: "Đơn vị công tác",
    Title: "Chọn nhân viên",
    validateNotSelectEmployee: "Bạn chưa chọn nhân viên. Vui lòng kiểm tra lại!",
    errorSelectEmployeeMix:
      "Bạn đang chọn cả nhân viên ngừng theo dõi để cấp phát. Bạn có muốn hệ thống chỉ thực hiện cấp phát cho nhân viên đang theo dõi không?",
    errorSelectEMployeeInactive:
      "Chỉ được cấp phát cho nhân viên đang theo dõi. Vui lòng kiểm tra lại!",
  },

  SelectAsset: {
    errorNotSelectAsset: "Chưa chọn tài sản. Vui lòng kiểm tra lại.",
  },

  SelectEmployee: {
    errorNotSelectEmployee: "Chưa chọn nhân viên. Vui lòng kiểm tra lại.",
  },

  SelectManagerFormm: {
    Title: "Chọn người quản lý",
  },
};
